import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
} from '@mui/material';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import Select from "../../Common/Select";
import Input from '../../Common/InputField';
import Routes from '../../../routes';
import { toastResponseError } from '../../../utils';

import CommonModal from '../../Common/CommonModal';


const ApproveWorkOrderModal = ({ id, modalOpen, onClose, refreshRequired }) => {
    const fileInput = useRef();
    const [laborCost, setLaborCost] = useState(null);
    const [materialCost, setMaterialCost] = useState(null);
    const [fieldsError, setManditoryFieldError] = useState(null)


    var SaveApprove = async () => {
        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ID: id,
                LaborCost: laborCost,
                MaterialCost: materialCost
            })
        }

        const UpdateResponse = await fetch(Routes.WorkOrder.UpdateApprove(), postConfig)
        if (UpdateResponse.status == 200) {
            onClose()
            refreshRequired()
        } else {
            // AB#17142: a forbidden or failed approval used to fail silently
            await toastResponseError(UpdateResponse, 'Failed to approve the work order.');
        }
    }

    return (
        <CommonModal open={modalOpen} close={() => onClose()} header={`Approve Work Order #${id}`}>
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                {
                    fieldsError == true && (
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                            <Typography sx={{ padding: '1% 0%', fontSize: 17, fontWeight: 600 }}>
                                Total Cost ($) : ${parseInt(laborCost) + parseInt(materialCost)}
                            </Typography>
                        </Grid>
                  )
                }
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        type="number"
                        label="Labor Cost"
                        value={laborCost}
                        onChange={e => setLaborCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        type="number"
                        label="Material Cost"
                        value={materialCost}
                        onChange={e => setMaterialCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    {
                        (isNaN(parseInt(laborCost)) || isNaN(parseInt(materialCost))) ? (
                    <Typography sx={{ padding: '1% 0%', fontSize: 17, fontWeight: 600 }}>
                        Total Cost ($) : Not Set
                    </Typography>
                    ) : (
                    <Typography sx={{ padding: '1% 0%', fontSize: 17, fontWeight: 600 }}>
                        Total Cost ($) : ${parseInt(laborCost) + parseInt(materialCost)}
                    </Typography>
                    )
                    }
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            onClick={() => SaveApprove()}
                            size='large'
                            variant='contained'
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                APPROVE WORK ORDER
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};

//ReOpenModal.propTypes = {
//    id: PropTypes.string.isRequired,
//    open: PropTypes.bool.isRequired,
//    closeModal: PropTypes.func.isRequired,
//    setDataRefresh: PropTypes.func.isRequired,
//};

export default ApproveWorkOrderModal;
